import { render, staticRenderFns } from "./TurnTicketBlocks.vue?vue&type=template&id=4a0dcf0f"
import script from "./TurnTicketBlocks.vue?vue&type=script&lang=js"
export * from "./TurnTicketBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports